// extracted by mini-css-extract-plugin
export default {"OpcVIew":"OpcView_OpcVIew__h3R1r"};